import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEnvironmentConfig } from '@core/models';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private configSubject = new ReplaySubject<IEnvironmentConfig>(1);
  private config: IEnvironmentConfig | null = null;

  config$ = this.configSubject.asObservable();

  constructor(private readonly http: HttpClient) {}

  loadConfig(): Observable<IEnvironmentConfig> {
    return this.http.get<IEnvironmentConfig>('/assets/config.json').pipe(
      tap((config) => {
        this.config = config;
        this.configSubject.next(config);
      }),
    );
  }

  getConfig(): IEnvironmentConfig | null {
    return this.config;
  }

  get production(): boolean {
    return this.config?.production ?? false;
  }

  get productName(): string {
    return this.config?.productName ?? '';
  }

  get apiUrl(): string {
    return this.config?.apiUrl ?? '';
  }

  get zendeskUrl(): string {
    return this.config?.zendeskUrl ?? '';
  }

  get zendeskLogout(): boolean {
    return this.config?.zendeskLogout ?? false;
  }

  get postLogoutUri(): string {
    return this.config?.postLogoutUri ?? '';
  }

  get sentryEnable(): boolean {
    return this.config?.sentryEnable ?? false;
  }

  get sentryDNS(): string {
    return this.config?.sentryDNS ?? '';
  }

  get sentryENV(): string {
    return this.config?.sentryENV ?? '';
  }

  get idleTime(): number {
    return this.config?.idleTime ?? 1680000;
  }

  get timeoutTime(): number {
    return this.config?.timeoutTime ?? 120;
  }

  get restoreTokenTime(): number {
    return this.config?.restoreTokenTime ?? 960000;
  }

  get staticToken(): string | undefined {
    return this.config?.staticToken;
  }

  get feedbackEmail(): string {
    return this.config?.feedbackEmail ?? 'product-dev@diliko.ai';
  }
}
